package resources

import com.essntl.essntl_common.generated.resources.*
import com.essntl.essntl_common.generated.resources.Res
import com.essntl.uikit.resources.EsResources
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.ExperimentalResourceApi
import org.jetbrains.compose.resources.FontResource

@OptIn(ExperimentalResourceApi::class)
class EsResourcesImpl : EsResources {
    override val logo: DrawableResource
        get() = Res.drawable.logo

    override suspend fun getBeLogo(): ByteArray =
        Res.readBytes("files/be_logo.png")

    override val arrowLeft: DrawableResource
        get() = Res.drawable.arrow_left

    override val refresh: DrawableResource
        get() = Res.drawable.refresh

    override val person: DrawableResource
        get() = Res.drawable.person

    override val arrowIconRight: DrawableResource
        get() = Res.drawable.arrow_icon_right

    override val arrowIconDown: DrawableResource
        get() = Res.drawable.arrow_icon_down

    override val world: DrawableResource
        get() = Res.drawable.world

    override val arrowUp: DrawableResource
        get() = Res.drawable.arrow_up

    override val arrowRight: DrawableResource
        get() = Res.drawable.arrow_right

    override val arrowDown: DrawableResource
        get() = Res.drawable.arrow_down

    override val moreVertical: DrawableResource
        get() = Res.drawable.more_vertical

    override val crm: DrawableResource
        get() = Res.drawable.crm

    override val moreHorizontal: DrawableResource
        get() = Res.drawable.more_horizontal

    override val infoCircle: DrawableResource
        get() = Res.drawable.info_circle

    override val checkCircle: DrawableResource
        get() = Res.drawable.check_circle

    override val check: DrawableResource
        get() = Res.drawable.check

    override val drag: DrawableResource
        get() = Res.drawable.drag

    override val edit: DrawableResource
        get() = Res.drawable.edit

    override val search: DrawableResource
        get() = Res.drawable.search

    override val add: DrawableResource
        get() = Res.drawable.add

    override val publish: DrawableResource
        get() = Res.drawable.publish

    override val browse: DrawableResource
        get() = Res.drawable.browse

    override val category: DrawableResource
        get() = Res.drawable.category

    override val minus: DrawableResource
        get() = Res.drawable.minus

    override val trash: DrawableResource
        get() = Res.drawable.trash

    override val timer: DrawableResource
        get() = Res.drawable.timer

    override val baseInformation: DrawableResource
        get() = Res.drawable.base_information

    override val calendar: DrawableResource
        get() = Res.drawable.calendar

    override val filter: DrawableResource
        get() = Res.drawable.filter

    override val sort: DrawableResource
        get() = Res.drawable.sort

    override val service: DrawableResource
        get() = Res.drawable.service

    override val itinerary: DrawableResource
        get() = Res.drawable.itinerary

    override val concierge: DrawableResource
        get() = Res.drawable.concierge

    override val suppliers: DrawableResource
        get() = Res.drawable.suppliers

    override val request: DrawableResource
        get() = Res.drawable.request

    override val noteFavorite: DrawableResource
        get() = Res.drawable.note_favorite

    override val proposal: DrawableResource
        get() = Res.drawable.proposal

    override val task: DrawableResource
        get() = Res.drawable.task

    override val spinnerLarge: DrawableResource
        get() = Res.drawable.spinner_large

    override val spinnerMedium: DrawableResource
        get() = Res.drawable.spinner_medium

    override val spinnerSmall: DrawableResource
        get() = Res.drawable.spinner_small

    override val close: DrawableResource
        get() = Res.drawable.close

    override val closeCircle: DrawableResource
        get() = Res.drawable.close_circle

    override val tick: DrawableResource
        get() = Res.drawable.tick

    override val travelers: DrawableResource
        get() = Res.drawable.travelers

    override val link: DrawableResource
        get() = Res.drawable.link

    override val listBulleted: DrawableResource
        get() = Res.drawable.list_bulleted

    override val listNumbered: DrawableResource
        get() = Res.drawable.list_numbered

    override val textBold: DrawableResource
        get() = Res.drawable.text_bold

    override val textItalic: DrawableResource
        get() = Res.drawable.text_italic

    override val textUnderline: DrawableResource
        get() = Res.drawable.text_underline

    override val textStrikethrough: DrawableResource
        get() = Res.drawable.text_strikethrough

    override val colorItem: DrawableResource
        get() = Res.drawable.color_item

    override val textAlignLeft: DrawableResource
        get() = Res.drawable.text_align_left

    override val copy: DrawableResource
        get() = Res.drawable.copy

    override val eye: DrawableResource
        get() = Res.drawable.eye

    override val share: DrawableResource
        get() = Res.drawable.share

    override val emptyList: DrawableResource
        get() = Res.drawable.empty_list

    override val emptySearch: DrawableResource
        get() = Res.drawable.empty_search

    override val contactIcon: DrawableResource
        get() = Res.drawable.contact_icon

    override val map: DrawableResource
        get() = Res.drawable.map

    override val date: DrawableResource
        get() = Res.drawable.date

    override val location: DrawableResource
        get() = Res.drawable.location

    override val boardIcon: DrawableResource
        get() = Res.drawable.board_icon

    override val clients: DrawableResource
        get() = Res.drawable.clients

    override val requestList: DrawableResource
        get() = Res.drawable.list_icon_request

    override val arrowBack: DrawableResource
        get() = Res.drawable.arrow_back

    override val crown: DrawableResource
        get() = Res.drawable.crown

    override val beLogoFullNude: DrawableResource
        get() = Res.drawable.be_logo_full_nude

    override val dollarSquare: DrawableResource
        get() = Res.drawable.dollar_square

    override val addImage: DrawableResource
        get() = Res.drawable.add_image

    override val addProposalImage: DrawableResource
        get() = Res.drawable.add_proposal_image

    override val aiEssntl: DrawableResource
        get() = Res.drawable.ai_essntl

    override val searchImage: DrawableResource
        get() = Res.drawable.search_image

    override val home: DrawableResource
        get() = Res.drawable.home
    override val attachment: DrawableResource
        get() = Res.drawable.attachment

    override val list: DrawableResource
        get() = Res.drawable.list

    override val board: DrawableResource
        get() = Res.drawable.board

    override val download: DrawableResource
        get() = Res.drawable.download

    override val expand: DrawableResource
        get() = Res.drawable.expand

    override val addSquare: DrawableResource
        get() = Res.drawable.add_square

    override val phone: DrawableResource
        get() = Res.drawable.phone

    override val group: DrawableResource
        get() = Res.drawable.group

    override val settings: DrawableResource
        get() = Res.drawable.settings
    override val star: DrawableResource
        get() = Res.drawable.star
    override val filePicker: DrawableResource
        get() = Res.drawable.file_picker
    override val emojiPicker: DrawableResource
        get() = Res.drawable.emoji_picker
    override val send: DrawableResource
        get() = Res.drawable.send

    override val mail: DrawableResource
        get() = Res.drawable.mail

    override val sms: DrawableResource
        get() = Res.drawable.sms

    override val whatsapp: DrawableResource
        get() = Res.drawable.whatsapp

    override val arrange: DrawableResource
        get() = Res.drawable.arrange

    override val messages: DrawableResource
        get() = Res.drawable.messages

    override val doubleTick: DrawableResource
        get() = Res.drawable.double_tick

    override val menu: DrawableResource
        get() = Res.drawable.menu

    override val userAvatar: DrawableResource
        get() = Res.drawable.user_avatar

    override val authPicture: DrawableResource
        get() = Res.drawable.auth_picture

    override val authMobilePicture: DrawableResource
        get() = Res.drawable.auth_mobile_picture

    override val google: DrawableResource
        get() = Res.drawable.google

    override suspend fun readBytes(path: String): ByteArray = Res.readBytes(path)

    override val manropeExtraLight: FontResource
        get() = Res.font.Manrope_ExtraLight

    override val manropeLight: FontResource
        get() = Res.font.Manrope_Light

    override val manropeRegular: FontResource
        get() = Res.font.Manrope_Regular

    override val manropeMedium: FontResource
        get() = Res.font.Manrope_Medium

    override val manropeSemiBold: FontResource
        get() = Res.font.Manrope_SemiBold

    override val manropeBold: FontResource
        get() = Res.font.Manrope_Bold

    override val manropeExtraBold: FontResource
        get() = Res.font.Manrope_ExtraBold
}
